import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, finalize } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    login(username: any, password: any) {
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/login`, { username, password }, { withCredentials: true })
            .pipe(map(user => {
                // refresh_token is set as an HTTP-only cookie by the server (not in response body)
                localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
                return user;
            }));
    }

    refresh() {
        // browser sends the HTTP-only refresh_token cookie automatically
        return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/refresh`, {}, { withCredentials: true })
            .pipe(map(res => {
                localStorage.setItem(`${environment.appName}` + 'user', res.data.access_token);
                return res;
            }));
    }

    logout() {
        // browser sends the HTTP-only refresh_token cookie automatically
        this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/logout`, {}, { withCredentials: true })
            .pipe(finalize(() => {
                localStorage.removeItem(`${environment.appName}` + 'user');
                this.router.navigate(['/login']);
            }))
            .subscribe({ error: () => {} });
    }
}
